import { IInstructionDTO } from '../../dto/instruction/instruction.dto';
import { IInstructionStepDTO } from '../../dto/instruction/instruction-step.dto';

const instructionStepDTOs: IInstructionStepDTO[] = [
  {
    title: $localize`:@@page-video-downloader-content-instruction-section-step-0-title:Get the video URL`,
    description: $localize`:@@page-video-downloader-content-instruction-section-step-0-description:Go to the Instagram post containing the video you want to download. Copy the URL directly from your browser’s address bar.`,
  },
  {
    title: $localize`:@@page-video-downloader-content-instruction-section-step-1-title:Paste the link into our downloader`,
    description: $localize`:@@page-video-downloader-content-instruction-section-step-1-description:Head to our website and input the link into the designated field in the Instagram video downloader.`,
  },
  {
    title: $localize`:@@page-video-downloader-content-instruction-section-step-2-title:Click the download button`,
    description: $localize`:@@page-video-downloader-content-instruction-section-step-2-description:Once the link is pasted, click on the \"Download\" button. The tool will process your request instantly.`,
  },
  {
    title: $localize`:@@page-video-downloader-content-instruction-section-step-3-title:Enjoy your saved videos`,
    description: $localize`:@@page-video-downloader-content-instruction-section-step-3-description:After the download, you can access your videos anytime, without any restrictions.`,
  },
];

export const instructionDTO: IInstructionDTO = {
  title: $localize`:@@page-video-downloader-content-instruction-section-title:How to download Instagram videos easily`,
  header: $localize`:@@page-video-downloader-content-instruction-section-header:Follow these steps to get started:`,
  steps: instructionStepDTOs,
  footer: $localize`:@@page-video-downloader-content-instruction-section-footer:Our video downloader gives you the power to download Instagram videos easily. Try it now and experience fast, seamless downloads!`,
};
